import {
  TTabKey,
} from './audit-trail.ts';

const tabs: Record<TTabKey, string> = {
  settings: 'Nastavenia',
  events: 'Udalosti',
};

export default {
  tabs,
};
